<template>
  <v-container fluid
    class="d-flex flex-row justify-space-between"
  >
    {{name}}

    <v-spacer/>
        
    <template
      v-if="editing || editOnly"
    >
      <v-btn
        icon
        elevation="0"
        small
        v-if="dirty"
        @click="saveContent"
      >
        <v-icon
          small
          color="green"
        >mdi-content-save</v-icon>
      </v-btn>

      <v-btn
        icon
        elevation="0"
        small
        @click="toggleEditPreview"
      >
        <v-icon
          small
        >{{editMode == 1 ? 'mdi-text' : $vuetify.breakpoint.mobile ? 'mdi-view-split-horizontal' : 'mdi-view-split-vertical'}}</v-icon>
      </v-btn>

    </template>

    <v-btn
      icon
      elevation="0"
      small
      @click="toggleEdit"
    >
      <v-icon
        small
      >{{editing || editOnly ? 'mdi-close' : 'mdi-pencil'}}</v-icon>
    </v-btn>

  </v-container>
</template>
<script>
export default {
  props:['mode', 'dirty', 'dialog', 'name', 'editOnly'],
  data(){
    return {
      editing: false,
      editMode: 0, 
      modes: ['editor', 'preview'],
    }
  },
  methods:{
    saveContent(){
      this.$emit('save')
      this.toggleEdit()
    },
    toggleEdit(){
      if (this.dialog) {
        this.$emit('dialogEdit', true)        
      } else if(this.editOnly) {
        this.$emit('close')
      } else {
        this.editing = !this.editing
        let mode = this.editing ? this.modes[this.editMode] : 'viewer'
        this.$emit('change', mode)
      }
    },
    toggleEditPreview(){
      this.editMode = this.editMode == 1 ? 0 : 1
      if (this.editing) {
        this.$emit('change', this.modes[this.editMode])
      }
    }
  }
}
</script>